import React from 'react'
import { Box } from '@mui/material'
import { motion } from 'framer-motion'
import { styled } from '@mui/material/styles'
import { InterstitialStage } from '../../../../../types/ui'
import { tonalPalettes } from '@zuto/theme/src/mui/Colors'

const MotionBox = motion.create(Box)

const Spinner = styled(MotionBox)(() => ({
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  borderWidth: '2px',
  borderStyle: 'solid',
  borderColor: tonalPalettes.neutralWarm[80],
  borderTopColor: tonalPalettes.neutralVariant[0],
  display: 'inline-block'
}))

type LoadingSpinnerProps = {
  stage: InterstitialStage
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ stage }) => {
  if (stage === 'complete') return null

  return (
    <Box sx={{ textAlign: 'center' }}>
      <Spinner
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
      />
    </Box>
  )
}

export default LoadingSpinner
